<sd-component-wrapper [content]="accessorySearchWrapper" [themesConfig]="accessorySearchBackgroundTheme">
  <form sd-component-wrapper-component novalidate [formGroup]="formGroup" class="d-column" id="accessory-search">
    <sd-border-wrapper>
      <div class="d-flex c__form-row">
        <div class="c__form-item">
          <sd-form
            autocomplete
            formControlName="autocomplete"
            [properties]="['term']"
            [clearAfterSelectElement]="false"
            [elements]="autocompleteElement"
            idField="element_id1"
            [placeholder]="'accessory.search.ass' | translate"
            [minLength]="2"
            (inputChanged)="searchProduct($event)"
          />
          <div class="c__how-to-find">
            <a class="has-icon d-flex align-items-center" (click)="openModalRef()">
              <sd-icon name="icon-help" [size]="iconSize.xs" />
              {{ 'accessory.search.findMyAss' | translate }}
            </a>
          </div>
          <div class="c__login-link" [hidden]="isLogged" style="margin-top: 20px">
            <a (click)="login()">{{ 'accessory.search.connectUser' | translate }}</a>
          </div>
        </div>
        <div class="c__actions">
          <button sd-button (click)="onSubmit()" (keydown.enter)="onSubmit()" [disabled]="isSearchProduct">
            <span> {{ 'accessory.search.searchButton' | translate }}</span>
          </button>
        </div>
      </div>

      <div [hidden]="!isLogged">
        <sd-title [titleLevel]="4" customClass="c__title is-body-s is-bold" [isDescription]="true">
          {{ 'accessory.search.searchSavedProductTitle' | translate }}
        </sd-title>
        <div class="d-flex c__form-row">
          <div class="c__form-item">
            <sd-form
              select
              [items]="savedProductItems"
              valueKey="code"
              libelleKey="name"
              [labelHidden]="true"
              [placeholder]="'accessory.search.savedProduct' | translate"
              (valueChanged)="setSelectedProduct($event)"
              [disabled]="savedProductItems?.length < 1"
            />
            @if (savedProductItems?.length < 1) {
              <div class="c__how-to-find">
                <span class="has-icon d-flex align-items-center">
                  {{ 'accessory.search.noRegisteredProduct' | translate }}
                </span>
              </div>
            }
          </div>
          <div class="c__actions">
            <button
              sd-button
              [routerLink]="urlSearchSavedProduct"
              [disabled]="isSearchSavedProduct"
              (click)="onSavedProductsSearchEventClicked()"
            >
              <span> {{ 'accessory.search.searchButton' | translate }}</span>
            </button>
          </div>
        </div>
      </div>

      <p class="c__search-subtitle is-body-s is-bold">{{ 'accessory.search.title' | translate }}</p>
      <div class="d-flex c__form-row">
        <div class="c__form-item">
          <sd-form
            select
            [items]="categoryItems"
            valueKey="code"
            libelleKey="name"
            [labelHidden]="true"
            [placeholder]="'accessory.search.category' | translate"
            (valueChanged)="setCategory($event)"
          />
          <span>{{ 'accessory.search.ex.category' | translate }}</span>
        </div>
        <div class="c__form-item">
          <sd-form
            select
            [items]="subCategoryItems()"
            [formControl]="subCategoryControl"
            valueKey="code"
            libelleKey="name"
            [labelHidden]="true"
            [placeholder]="'accessory.search.subCategory' | translate"
            (valueChanged)="setSubCategory($event)"
          />
          <span>{{ 'accessory.search.ex.subCategory' | translate }}</span>
        </div>
        <div class="c__form-item">
          <sd-form
            select
            [items]="productItems()"
            [formControl]="productControl"
            valueKey="code"
            libelleKey="name"
            [labelHidden]="true"
            [placeholder]="'accessory.search.product' | translate"
            (valueChanged)="setProduct($event)"
          />
          <span>{{ 'accessory.search.ex.product' | translate }}</span>
        </div>
        <div class="c__form-item">
          <sd-form
            select
            [items]="accessoryItems()"
            [formControl]="accessoryControl"
            valueKey="code"
            libelleKey="name"
            [labelHidden]="true"
            [placeholder]="'accessory.search.accessory' | translate"
            (valueChanged)="setAccessory($event)"
          />
          <span>{{ 'accessory.search.ex.accessory' | translate }}</span>
        </div>

        <div class="c__actions">
          <button
            sd-button
            [disabled]="isSearchCategoryHidden"
            [routerLink]="urlSearchAccessory"
            (click)="onAccessorySearchEventClicked()"
          >
            <span> {{ 'accessory.search.searchButton' | translate }}</span>
          </button>
        </div>
      </div>
    </sd-border-wrapper>
  </form>
  @defer (when isRefModalOpened) {
  <sd-modal-default
    [(isOpened)]="isRefModalOpened"
    [noPadding]="true"
    [modalTitleLevel]="4"
    [modalTitle]="'accessory.search.modal.title' | translate"
    >
    <div sd-modal-body>
      <div>{{ 'accessory.search.modal.text' | translate }}</div>
      <br />
      <div>{{ 'accessory.search.modal.example' | translate }}</div>
      <sd-banner [media]="{ url: urlImage }" style="max-width: 42.6rem; margin: 2rem auto 0" />
    </div>
  </sd-modal-default>
}
</sd-component-wrapper>
